import React from 'react';
import Header from '../../header/header';
import Footer from '../../footer/footer';
import ImageSlider from '../halloween/carrousselhalloween';





const APropos = (props) => {
  return (

    <div>  
            <Header />

    <div id="activites">

      <div className="container">
           <div className="col-xs-12 col-md-12">
<br></br>
<br></br>
        <div className="section-title">
          <h2>Actualités du moment</h2>
            <br></br>
              <br></br>
                  <div className="activites-list">


<h3>Octobre rose</h3>
<br></br>
<br></br>

<div className="col-xs-12 col-md-6">
<img className="img-responsive" src="../img/version1/apropos/octobrerose/octobrerose.jpg" alt="Atelier floral crèche Chennevières-sur-Marne - création bouquet fleurs Delphia Paul fleuriste 94" style={{ width: "400px", height: "auto" }} />
<br></br><br></br></div>
<div className="col-xs-12 col-md-6">

 <p>
Comme les fleurs, chaque femme est unique, belle et précieuse.
      </p>
<br></br>
      <p>
Certaines traversent des saisons plus difficiles, mais continuent de faire preuve d’une force admirable.
      </p>
<br></br>
<p>En ce mois d’Octobre Rose, DELPHIA PAUL adresse une pensée tendre à toutes les femmes, touchées de près ou de loin par le cancer du sein.
</p>
<br></br>
<p>Prenez soin de vous, soutenez-vous, aimez-vous… et continuez de fleurir, à votre rythme. 🌸💕
</p><br></br>
</div>



<br></br>
<div className="col-xs-12 col-md-12">
<h3 text align="center">___________</h3><br></br>
<br></br></div>

<div className="col-xs-12 col-md-12">
<h3>Halloween</h3>
<br></br>
<br></br>


<ImageSlider /><br></br><br></br>
  <p>
        🌸 Nouveau chez DELPHIA PAUL !
      </p>
<br></br>
      <p>
       Je suis heureuse de vous présenter mes Ateliers Floraux, pensés pour les enfants, adultes et seniors. 💐
      </p>
<br></br>
    
<p>Des moments créatifs et conviviaux pour créer, partager et apprendre autour des fleurs. 🌷✨
</p>
<br></br>
   <p>📩 Informations & réservations en message privé</p>
      <p>📞 06 25 00 67 53</p>
<br></br>
<br></br>
      </div>
<br></br>
<br></br>

<br></br>




        </div>


         
   
      </div>
      </div>
      </div>
  </div>
      < Footer />

    </div>

  );
};
    


export default APropos;